/**
 * Firebase web config, chosen at build time.
 *
 * Production values are the defaults, so a build without REACT_APP_FIREBASE_*
 * variables (local, CI, the production deploy) behaves exactly as before.
 * The staging preview workflow sets the variables to point the build at the
 * staging Firebase project. These values are public client identifiers,
 * not secrets.
 */
type Env = Record<string, string | undefined>;

const PRODUCTION_CONFIG = {
  apiKey: "AIzaSyCyA-H_VNy8nNu6AuWTjDKSbsvv-HkNOX4",
  authDomain: "beyond-reality-b4944.firebaseapp.com",
  projectId: "beyond-reality-b4944",
  storageBucket: "beyond-reality-b4944.appspot.com",
  messagingSenderId: "360712534263",
  appId: "1:360712534263:web:17635a0aa67062d0293bf2",
  measurementId: "G-8VX882357Z",
};

const PRODUCTION_VAPID_KEY =
  "BE-0nnaXCXreGR5T9qnnOkjS6bGtxuJPP_LiJ8ZxcR8N2NKBM9xubhUe8DSLde9BUl7F1Xs8lw_pAaQGUwDEQ6s";

export type FirebaseWebConfig = typeof PRODUCTION_CONFIG;

/**
 * Returns the production config unless REACT_APP_FIREBASE_PROJECT_ID is set,
 * in which case every field must come from the environment. Mixing staging
 * and production values would silently talk to the wrong project, so a
 * partial override throws.
 */
export const getFirebaseConfig = (env: Env): FirebaseWebConfig => {
  if (!env.REACT_APP_FIREBASE_PROJECT_ID) return PRODUCTION_CONFIG;

  const config = {
    apiKey: env.REACT_APP_FIREBASE_API_KEY,
    authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: env.REACT_APP_FIREBASE_APP_ID,
    measurementId: env.REACT_APP_FIREBASE_MEASUREMENT_ID ?? "",
  };
  const missing = Object.entries(config)
    .filter(([key, value]) => key !== "measurementId" && !value)
    .map(([key]) => key);
  if (missing.length > 0) {
    throw new Error(
      `REACT_APP_FIREBASE_PROJECT_ID is set but these Firebase config values are missing: ${missing.join(", ")}`
    );
  }
  return config as FirebaseWebConfig;
};

/** VAPID key for Firebase Cloud Messaging push subscriptions. */
export const getVapidKey = (env: Env): string =>
  env.REACT_APP_FIREBASE_PROJECT_ID
    ? env.REACT_APP_FIREBASE_VAPID_KEY ?? ""
    : PRODUCTION_VAPID_KEY;
